<script setup>
import { DialogTitle, useForwardProps } from "reka-ui";

const props = defineProps({
  asChild: { type: Boolean, default: false },
  as: { type: [String, Object], default: "h2" },
});

const forwarded = useForwardProps(props);
</script>

<template>
  <DialogTitle v-bind="forwarded" class="dialog-title">
    <slot />
  </DialogTitle>
</template>

<style lang="scss" scoped>
@use "@/colors" as c;
@use "@/styles/mixins/typography";

.dialog-title {
  @include typography.large("semi-bold");

  margin: 0;
  color: c.$text;
}
</style>
